import type { FunctionComponent } from "react";
import { Text } from "@kanda-libs/ks-design-library";
import Link from "components/shared/Link";
import useJobCompanyDetailsProps from "components/job/JobLayout/JobCompanyDetails/useJobCompanyDetailsProps";
import CompanyRiskFlag from "components/company/CompanyRiskFlag";

export interface JobCompanyDetailsProps {}

const JobCompanyDetails: FunctionComponent<JobCompanyDetailsProps> =
  function () {
    const { name, email, phone, address, link, isLoading, cid } =
      useJobCompanyDetailsProps();

    return (
      <Link
        to={link}
        className="flex flex-col px-5 py-4 mb-2 border rounded-lg border-neutral-300 last:mb-0 shadow-card"
      >
        <div className="flex flex-col">
          <Text
            text="From:"
            className="mb-2 text-20-24-em"
            isLoading={isLoading}
          />
          <div className="flex flex-row">
            <div className="flex min-w-32">
              <Text
                text="Name:"
                className="mr-2 text-14-22-em"
                isLoading={isLoading}
              />
            </div>
            <Text text={name} className="text-14-22" isLoading={isLoading} />
          </div>
          <div className="flex flex-row">
            <div className="flex min-w-32">
              <Text
                text="Email:"
                className="mr-2 text-14-22-em"
                isLoading={isLoading}
              />
            </div>
            <Text text={email} className="text-14-22" isLoading={isLoading} />
          </div>
          <div className="flex flex-row">
            <div className="flex min-w-32">
              <Text
                text="Phone:"
                className="mr-2 text-14-22-em"
                isLoading={isLoading}
              />
            </div>
            <Text text={phone} className="text-14-22" isLoading={isLoading} />
          </div>
          <div className="flex flex-row">
            <div className="flex min-w-32">
              <Text text="Address:" className="mr-2 text-14-22-em" />
            </div>
            <Text text={address} className="text-14-22" isLoading={isLoading} />
          </div>
          <div className="flex flex-row">
            <div className="flex min-w-32">
              <Text
                text="Risk:"
                className="mr-2 text-14-22-em"
                isLoading={isLoading}
              />
            </div>
            <Text
              text={<CompanyRiskFlag id={cid} />}
              className="text-14-22"
              isLoading={isLoading}
            />
          </div>
        </div>
      </Link>
    );
  };

export default JobCompanyDetails;
